

























































































































import {Vue, Component} from 'vue-property-decorator';
import {Utils} from '@/utils/Utils';
import {API} from '@/services/api/api';
import {mapActions} from 'vuex';

@Component({
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
})
export default class AdminProfile extends Vue {
  // constructor() {
  //   super();
  //   this.nonEditableMode = true;
  //   this.changeButtons = false;
  // }

  //store variables
  showSuccessToast: any;
  showErrorToast: any;

  //form variables
  clientId: any = null;
  name = '';
  email = '';
  phone: any = null;
  webpage = '';
  postalCode: any = null;
  address = '';
  comment = '';

  //validation variables
  nameValidationMsg: any = null;
  emailValidationMsg: any = null;
  phoneValidationMsg: any = null;
  pcodeValidationMsg: any = null;
  addressValidationMsg: any = null;
  onNullValidationMsg = 'This field is required.';

  //other variables
  nonEditableMode = true; // if true can not write/edit form
  changeButtons = false; //swap buttons based upon condition
  loadingBtnStatus = false;
  clientApiResponse = []; // list of client from api

  mounted() {
    this.getClientDetails();
  }

  //get particular client details from api
  async getClientDetails() {
    try {
      let apiResponse = await API.getClientList();
      if (apiResponse.data) {
        this.clientApiResponse = apiResponse.data;
        this.clientId = apiResponse.data[0].clientId;
        this.name = apiResponse.data[0].name;
        this.email = apiResponse.data[0].email;
        this.phone = apiResponse.data[0].phone;
        this.postalCode = apiResponse.data[0].postalCode;
        this.webpage = apiResponse.data[0].webpage;
        this.address = apiResponse.data[0].address;
        this.comment = apiResponse.data[0].comment;
      } else {
        this.showErrorToast({msg: apiResponse.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
    }
  }

  validateName() {
    if (this.name.length < 1 || this.name === '') {
      this.nameValidationMsg = this.onNullValidationMsg;
      return false;
    } else if (!Utils.validateName(this.name)) {
      this.nameValidationMsg = 'Minimum 6 character required only alphabets.';
      return false;
    } else this.nameValidationMsg = null;
    return true;
  }

  validateEmail() {
    if (this.email === '' || this.email === null) {
      this.emailValidationMsg = this.onNullValidationMsg;
      return false;
    } else if (!Utils.validateEmail(this.email)) {
      this.emailValidationMsg = 'E-mail is not valid.';
      return false;
    } else {
      this.emailValidationMsg = null;
      return true;
    }
  }

  validatePhoneNumber() {
    if (this.phone === null || this.phone === '') {
      this.phoneValidationMsg = this.onNullValidationMsg;
      return false;
    } else if (this.phone.toString().length < 10 || this.phone.toString().length > 10) {
      this.phoneValidationMsg = 'Mobile number must be  10 digit only.';
      return false;
    } else {
      this.phoneValidationMsg = null;
      return true;
    }
  }

  validatePostalCode() {
    if (this.postalCode === null || this.postalCode === '') {
      this.pcodeValidationMsg = this.onNullValidationMsg;

      return false;
    } else if (this.postalCode.toString().length < 6 || this.postalCode.toString().length > 6) {
      this.pcodeValidationMsg = 'Postal code  must be 6 digit only.';
      return false;
    } else {
      this.pcodeValidationMsg = null;
      return true;
    }
  }

  validateAddress() {
    if (this.address === null || this.address === '') {
      this.addressValidationMsg = this.onNullValidationMsg;

      return false;
    } else if (this.address.trim().length < 5) {
      this.addressValidationMsg = 'Minimum 5  characters required.';
      return false;
    } else this.addressValidationMsg = null;

    return true;
  }

  validateAll() {
    return (
      this.validateName() &&
      this.validateEmail() &&
      this.validatePhoneNumber() &&
      this.validatePostalCode() &&
      this.validateAddress()
    );
  }

  async _updateHandler() {
    if (!this.validateAll()) return false;
    this.loadingBtnStatus = true;
    try {
      let apiResponse = await API.updateClientDetails(
        this.clientId,
        this.name,
        this.email,
        this.phone,
        this.webpage,
        this.postalCode,
        this.address,
        this.comment
      );
      this.loadingBtnStatus = false;
      if (apiResponse.data) {
        if (apiResponse.message === "Successfully updated client's profile") {
          apiResponse.message = 'Record updated successfully';
        }
        this.showSuccessToast({msg: apiResponse.message});
        this.swapButtons();
      } else {
        this.showErrorToast({msg: apiResponse.error});
      }
    } catch (error) {
      this.loadingBtnStatus = false;
      this.showErrorToast({msg: 'Network error'});
    }
  }

  //if client id is null new client will create
  async _createHandler() {
    if (!this.validateAll()) return;
    else {
      this.loadingBtnStatus = true;
      try {
        let apiResponse = await API.createClient(
          this.name,
          this.email,
          this.phone,
          this.webpage,
          this.postalCode,
          this.address,
          this.comment
        );
        this.loadingBtnStatus = false;
        if (apiResponse.data) {
          this.showSuccessToast({msg: apiResponse.message});
          this.swapButtons();
        } else {
          this.showErrorToast({msg: apiResponse.error});
        }
      } catch (error) {
        this.loadingBtnStatus = false;
        this.showErrorToast({msg: 'Network error'});
      }
    }
  }

  //swap buttons based upon input
  swapButtons() {
    this.changeButtons = !this.changeButtons;
    this.nonEditableMode = !this.nonEditableMode;
  }

  //cancel button handler
  _cancelHandler() {
    this.changeButtons = !this.changeButtons;
    this.nonEditableMode = !this.nonEditableMode;
    this.getClientDetails();
  }
}
